<template>
  <div id="serviceAgreement">
    <div class="head">用户服务协议</div>
    <div class="p">尊敬的用户：</div>
    <div class="p">
      您好！欢迎您（“用户”）注册并使用北京泛生子基因科技有限公司（“泛生子”）数据平台（以下简称
      “Brave”）。在用户注册及使用本平台之前，请认真阅读以下条款，点击“同意”，即表示用户确认已经阅读并理解、接受本《用户声明及使用条款》的所有内容：
    </div>
    <div class="p">
      1.在成为泛生子Brave用户前，用户确认已年满18周岁且具备中华人民共和国（不包括香港特别行政区、澳门特别行政区和台湾地区）法律规定的与用户行为相适应的民事行为能力。如用户不符合前述条件，则用户须在法定监护人的知情和同意下进行注册和使用。
    </div>
    <div class="p">
      2.用户同意提交自己的个人信息用于平台注册和登录，且有义务保证并保持提交的个人信息的准确性、真实性、合法性及有效性。泛生子有权审核用户提交的个人信息，但该审核不免除用户承担因填报或提交虚假信息、证件所引发的一切后果。
    </div>
    <div class="p">
      3.用户登录Brave时，平台将自动接收并记录用户的相关服务器数据，这些数据包括但不限于个人信息、IP地址、用户的查看及操作记录等。为平台维护的需要，泛生子可能使用用户的个人信息，向用户发出服务信息，用于提高平台的服务质量以及其他方面。
    </div>
    <div class="p">
      4.用户应当保护个人账号信息的安全，不得将账号信息告知他人，如有任何账号异常，请立即联系泛生子平台管理人员。非因泛生子责任（包括但不限于用户个人账号密码被盗/丢失、用户主动告知他人或与他人共享注册账户及数据平台内容）导致用户个人信息泄露，泛生子不承担任何责任。
    </div>
    <div class="p">
      5.平台为用户提供以往业务信息查询、数据及信息上传、分析等服务或支持，同时提供【知识库】等学术、行业信息等方面的资源。用户须保证基于平台进行的所有操作（包括但不限于Brave注册、登录，在Brave查看内容以及将数据/信息上传至Brave及对数据/信息进行的分析等）合法合规，不侵犯他人的合法权益，不违反个人信息保护、网络安全、遗传资源管理等任何方面相关政策、法律法规、规范性文件的规定。
    </div>
    <div class="p">
      6.平台上的【知识库】等学术、行业信息等方面的资源仅供参考。泛生子对Brave相关内容的真实性、准确性不作任何承诺或保证，用户对于Brave内容的使用及可能造成的后果均与泛生子无关，泛生子不承担任何责任。
    </div>
    <div class="p">
      7.用户拥有对其上传至Brave的数据及信息的管理权。用户应对数据及信息的真实性、安全性、合法性承担全部责任，并承担由此引发的一切后果。
    </div>
    <div class="p">8.不可抗力及其他免责事由：</div>
    <div class="p">
      （1）用户理解并同意，在使用Brave的过程中，可能会遇到不可抗力等风险因素，使平台服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，泛生子将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户造成的损失泛生子在法律允许的范围内免责。在法律允许的范围内，泛生子对以下情形导致的平台服务中断或受阻不承担责任：
    </div>
    <div class="p">a)受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</div>
    <div class="p">
      b)用户或泛生子的电脑软件、系统、硬件和通信线路出现故障；
    </div>
    <div class="p">c)用户操作不当；</div>
    <div class="p">d)用户通过非泛生子授权的方式使用平台服务；</div>
    <div class="p">e)其他泛生子无法控制或合理预见的情形</div>
    <div class="p">
      （2）用户理解并同意，在使用平台服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，泛生子不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给用户造成的损害负责。这些风险包括但不限于：
    </div>
    <div class="p">
      a)来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；
    </div>
    <div class="p">
      b)因使用平台服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；
    </div>
    <div class="p">c)其他因网络信息或用户行为引起的风险。</div>
    <div class="p">
      9.如发生下列情形之一，泛生子有权不经通知而冻结或注销用户的个人账户：
    </div>
    <div class="p">
      (1)用户提供的个人信息不真实且未能提供合理解释或证明；(2)用户违反相关政策、法律法规、规范性文件的约定；(3)按照法律法规规定或主管部门要求；(4)出于安全原因或其他必要的情形。
    </div>
    <div class="p">
      10.泛生子有权适时修订本用户声明及使用条款并通知用户，用户理解并愿意接受修订后的条款并受其约束。
    </div>
    <div class="p">
      11.泛生子Brave管理人员联系方式： galileo@genetronhealth.com
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
#serviceAgreement {
  height: 100vh;
  padding: 20px 23px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.head {
  width: 100%;
  //   height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 30px;
  margin-bottom: 6px;
  text-align: center;
}
.date {
  width: 100%;
  //   height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9095a7;
  line-height: 24px;
}
.title {
  width: 100%;
  //   height: 22px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 22px;
  padding-top: 40px;
  padding-bottom: 20px;
}
.titleTwo {
  width: 100%;
  //   height: 24px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 24px;
  margin-bottom: 20px;
}
.titleThree {
  display: block;
  width: 100%;
  //   height: 24px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 24px;
  margin-bottom: 20px;
}

.p {
  width: 100%;
  //   height: 144px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5f697d;
  line-height: 24px;
  margin-bottom: 20px;
  span {
    font-weight: bold;
  }
}
</style>
